<app-header
  [animateShadow]="activateHandsetLayout$ | async"
  [border]="activateHandsetLayout$ | async"
  [elevated]="!(activateHandsetLayout$ | async)">
  <button header-navigation mat-icon-button (click)="toggleSidenav()">
    <mat-icon>menu</mat-icon>
  </button>

  <div header-title class="d-flex w-100">
    <app-search #search></app-search>
    <button class="d-none d-sm-block add-button flat" mat-mini-fab color="primary" (click)="addPatient()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <button header-actions mat-icon-button [matMenuTriggerFor]="appMenu">
    <app-avatar [class.hidden]="!(account$ | async)" [src]="(account$ | async)?.photoURL" icon="account_circle"
      [placeholder]="false">
    </app-avatar>
  </button>
</app-header>

<mat-menu #appMenu="matMenu" yPosition="below" xPosition="before">
  <button mat-menu-item [routerLink]="['/account']" routerLinkActive="router-link-active">
    <mat-icon>person</mat-icon>
    <span>Account</span>
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>